import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import VMasker from "vanilla-masker";
import toString from "../utils";
class Currency extends PureComponent {
  static pattern = {
    precision: 2,
    separator: ".",
    delimiter: ",",
    zeroCents: false,
  };
  static conformToMask = (value, pattern = Currency.pattern) => {
    const formatedValue = VMasker.toMoney(toString(value), pattern);
    return formatedValue;
  };
  handleChange = (event) => {
    const { onChange } = this.props;
    const newEvent = event;
    newEvent.target.value = VMasker.toMoney(
      event.target.value,
      Currency.pattern
    );
    if (onChange) {
      onChange(newEvent);
    }
  };
  render() {
    const { inputRef, ...rest } = this.props;
    return <input {...rest} onChange={this.handleChange} />;
  }
}
Currency.defaultProps = {
  inputRef: null,
};
Currency.propTypes = {
  inputRef: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};
export default Currency;
